import { Link } from "react-router-dom";
import { Leaf, Globe } from "lucide-react";
import { useT } from "@/lib/i18n";

const LangSwitch = () => {
  const { lang, setLang } = useT();
  return (
    <div
      className="inline-flex items-center gap-1 border border-border/70 rounded-full p-0.5 bg-white/80 backdrop-blur"
      data-testid="lang-switch"
    >
      <Globe className="w-3 h-3 mx-2 text-muted-foreground" />
      {["it", "en"].map((code) => (
        <button
          key={code}
          onClick={() => setLang(code)}
          data-testid={`lang-${code}`}
          className={`text-xs font-semibold uppercase tracking-widest px-2 py-1 rounded-full transition-colors ${
            lang === code
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:text-primary"
          }`}
        >
          {code}
        </button>
      ))}
    </div>
  );
};

export const SiteHeader = ({ transparent = false }) => {
  const { t } = useT();
  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-40 ${
        transparent
          ? "bg-white/70 backdrop-blur-xl border-b border-white/40"
          : "bg-white/95 backdrop-blur border-b border-border"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="header-logo"
          className="flex items-center gap-3 group"
        >
          <span className="w-10 h-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center">
            <Leaf className="w-5 h-5" />
          </span>
          <div className="leading-tight">
            <div className="font-display text-xl text-primary">
              Due Pini Conte
            </div>
            <div className="text-[10px] tracking-[0.28em] uppercase text-muted-foreground">
              {t("nav.tagline")}
            </div>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm">
          <a
            href="/#dintorni"
            className="text-foreground/80 hover:text-primary"
            data-testid="nav-dintorni"
          >
            {t("nav.dintorni")}
          </a>
          <a
            href="/#gallery"
            className="text-foreground/80 hover:text-primary"
            data-testid="nav-gallery"
          >
            {t("nav.gallery")}
          </a>
          <a
            href="/#contatti"
            className="text-foreground/80 hover:text-primary"
            data-testid="nav-contatti"
          >
            {t("nav.contatti")}
          </a>
          <LangSwitch />
          <Link
            to="/prenota/pernottamenti"
            className="btn-primary pill px-5 py-2 text-sm"
            data-testid="nav-book-overnight"
          >
            {t("nav.prenota")}
          </Link>
        </nav>
        <div className="md:hidden">
          <LangSwitch />
        </div>
      </div>
    </header>
  );
};
